module.exports = __webpack_public_path__ + "static/media/maian.4f4e9044.jpg";